let allowTypeButtonClick = true;

function hidepackofSwatchFromBuildAPackPage() {
  const allColorSwatchButtons = document.querySelectorAll(".tab-swatch");
  allColorSwatchButtons.forEach((btn) => {
    const allColorSwatchProductHandles = btn.getAttribute("data-phanlde");

    if (allColorSwatchProductHandles && allColorSwatchProductHandles.includes("pack-of")) {
      console.warn(allColorSwatchProductHandles);
      btn.style.display = "none";
      btn.closest(".type_swatch").style.display = "none";
    }
  });
}

document.querySelectorAll('.m-product-option--node input[type="radio"]').forEach(input => {
  input.addEventListener('click', function () {
    const selectedValue = this.value;
    localStorage.setItem("size-selected", selectedValue);
  });
});

var allProductsData = {},
  commonProductsData = {};
function showAppropriateStep() {
  const t = new URLSearchParams(window.location.search);
  let e = t.get("step");
  const a = document.querySelectorAll("section[data-step]");
  if (!e) {
    const n = Array.from(a).find((t) => !t.classList.contains("hidden"));
    n &&
      ((e = n.dataset.step),
        t.set("step", e),
        window.history.replaceState(null, null, "?" + t.toString()));
  }
  localStorage.setItem("current-step", e),
    a.forEach((n) => {
      if (n.dataset.step === e) {
        if ((n.classList.remove("hidden"), "color-select" === e)) {
          document.querySelector(".page-step-1"),
            document.querySelector(".page-step-2"),
            document.querySelector(".page-step-3");
          if (!e) {
            const n = Array.from(a).find(
              (t) => !t.classList.contains("hidden")
            );
            n &&
              ((e = n.dataset.step),
                t.set("step", e),
                window.history.replaceState(null, null, "?" + t.toString()));
          }
          localStorage.setItem("current-step", e),
            setupTabButtonClickHandlers(),
            setupTabSwatchClickHandlers();
        }
      } else n.classList.add("hidden");
    });
}
function generateHtmlForCommonProducts() {
  let t = "";
  const e = new Set(),
    a = localStorage.getItem("size-selected");
  for (const n in commonProductsData) {
    const o = commonProductsData[n],
      c = o.tags || [];
    if (e.has(o.design_name)) continue;
    const r = Object.values(o.variants).find(
      (t) => t.title === a && t.inventory_quantity > 0
    );
    if (!r) continue;
    let s = "";
    c.some((t) => "prints" === t.toLowerCase()) && (s += "prints "),
      c.some((t) => "solids" === t.toLowerCase()) && (s += "solids "),
      c.some((t) => "new" === t.toLowerCase()) && (s += "new"),
      (t += `\n            <div class="type_swatch all ${s.trim()}">\n                <button href="#" class="tab-swatch"\n                        data-name="${o.design_name
        }"\n                        data-type="${o.shape_style
        }"\n                        data-pid="${o.product_id
        }"\n                        data-phanlde="${o.product_handle
        }"\n                        data-previmg="${o.custom_tool_preview_image
        }"\n                        data-inventory="${r.inventory_quantity
        }"\n                        data-price="${o.price
        }"> \n                    <img src="${o.swatch_icon
        }">\n                </button>\n            </div>\n        `),
      e.add(o.design_name);
  }
  const n = document.querySelector(".preview-variant-inner");
  n && (n.innerHTML = t);
}

function setupTabButtonClickHandlers() {
  const t = document.querySelector(".review");
  if (!t) return;
  const e = t.querySelectorAll(".tab-button"),
    a = t.querySelectorAll(".type_swatch");
  e.forEach((t) => {
    t.addEventListener("click", function () {
      e.forEach((t) => t.classList.remove("active")),
        this.classList.add("active");
      const t = this.getAttribute("data-name");
      a.forEach((e) => {
        "all" === t || e.classList.contains(t)
          ? (e.style.display = "")
          : (e.style.display = "none");
      });
    });
  });
}
function updateDesignCounts() {
  const t = document.querySelector(".review");
  if (!t) return;
  const e = t.querySelectorAll(".tab-button"),
    a = t.querySelectorAll(".type_swatch");
  e.forEach((t) => {
    const e = t.getAttribute("data-name");
    let n = 0;
    a.forEach((t) => {
      ("all" === e || t.classList.contains(e)) && n++;
    });
    const o = t.querySelector(".design-count");
    o && (o.textContent = `(${n})`);
  });
}
function setupTabSwatchClickHandlers() {
  // prevent add-to-pack button start

  const buttonss = document.querySelector("#add-to-pack");
  buttonss.classList.add("disabledddd");
  buttonss.setAttribute("disabledddd", "true");
  // prevent add-to-pack button end

  const t = document.querySelector(".review");
  if (!t) return;
  const e = t.querySelectorAll(".tab-swatch"),
    a = t.querySelector(".type-label--selected");
  e.forEach((t) => {
    t.addEventListener("click", function () {
      allowTypeButtonClick = true; // explicitly allow tab-button click

      // prevent add-to-pack button start
      buttonss.classList.remove("disabledddd");
      buttonss.removeAttribute("disabledddd");
      // prevent add-to-pack button end

      e.forEach((t) => t.classList.remove("active")),
        this.classList.add("active");
      const t = this.closest(".m-section-my");
      t &&
        (window.matchMedia("(min-width: 768px)").matches
          ? t.scrollIntoView({ behavior: "smooth", block: "center" })
          : t.scrollIntoView({ behavior: "smooth", block: "start" }));
      let n = this.getAttribute("data-name"),
        o = this.getAttribute("data-pid"),
        c = this.getAttribute("data-phanlde"),
        r = this.getAttribute("data-previmg"),
        s = this.getAttribute("data-price");
      localStorage.setItem("designName", n),
        localStorage.setItem("product-id", o),
        localStorage.setItem("product-handle", c),
        localStorage.setItem("product-prev", r),
        localStorage.setItem("product-price", s);
        a && (a.textContent = n);
    });
  });
}
function findAllCommonProducts(t) {
  let e = [];
  e = allProductsData[`allProduct-${t}`];
  new Set(), Object.values(allProductsData).flat();
  return localStorage.setItem("commonProducts", JSON.stringify(e)), e;
}
function updateStepIndicators(t, e) {
  const a = document.querySelector(`${e} .matching-undie_step_conatiner`),
    n = document.querySelector(`${e} .matching-undie_step_conatiner_mobile`);
  a && n && (updateCounter(a, t, !0), updateCounter(n, t, !1));
}
function updateCounter(t, e, a, n) {
  t.querySelectorAll('[class*="matching-undie_steps_"]').forEach((t, n) => {
    const o = "matching-undie_steps_" + (n + 1);
    a
      ? t.classList.toggle("active", o <= e)
      : (t.classList.toggle("active", o === e),
        t.classList.toggle("hidden", o !== e));
  });
}
function generateHtmlForPacks(t) {
  let e = "";
  for (let a = 0; a < t; a++) {
    e += `
      <div class="pack-swatch">
        <div class="pack-swatch-button">
          <span class="close hidden">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path d="M8.80296 15.7091L15.1954 9.31663M15.1954 15.7091L8.80296 9.31663M11.9992 23.807C18.211 23.807 23.2933 18.7246 23.2933 12.5129C23.2933 6.3011 18.211 1.21875 11.9992 1.21875C5.78743 1.21875 0.705078 6.3011 0.705078 12.5129C0.705078 18.7246 5.78743 23.807 11.9992 23.807Z"
                stroke="black" stroke-opacity="0.7" stroke-width="1.41176" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <button href="#" class="pack-swatch-img"
            data-position="${a + 1}"
            data-type=""
            data-id=""
            data-handle=""
            data-size=""
            data-design=""
            data-prev=""
            data-price="">
            <img src="" data-filled="false" style="display: none;" onload="this.style.display='block';">
          </button>
          <span class="price"></span>
        </div>
      </div>
    `;
  }

  const countDisplay = document.querySelector("#count-static");
  const container = document.querySelector("#pack-prevew-div");
  if (container) {
    container.innerHTML = e;
    countDisplay.innerHTML = t;

    // ✅ Hide all img tags with empty src or data-filled="false"
    container.querySelectorAll('img').forEach(img => {
      if (!img.src || img.src.trim() === '' || img.getAttribute('data-filled') === 'false') {
        img.style.display = 'none';
      }
    });
  }
}

function handleSectionActions(t) {
  const e = document.querySelector(t);
  let a = e.getAttribute("data-step");
  if (!e) return;
  const n = e.querySelectorAll(
    ".m-richtext__button_outter .m-richtext__button[data-open]"
  ),
    o = e.querySelectorAll(".size-chart-pop"),
    c = e.querySelector(".tab-component"),
    r = e.querySelector("div[data-variant-picker]"),
    s = e.querySelector(".next-pack"),
    i = e.querySelectorAll('.m-product-option--node input[type="radio"]'),
    d = e.querySelector("img.prev_placeholder"),
    l = e.querySelector(".color-select-preview"),
    u =
      (document.querySelector(".page-step-1-review-title"),
        document.querySelector(".page-step-2-review-title"),
        e.querySelector("#pack-select")),
    m = e.querySelectorAll("#pack-select .p-richtext__button[data-quantity]"),
    p = e.querySelector("#type-select"),
    g = e.querySelectorAll(".m-content-box .type-select"),
    h = e.querySelectorAll(".m-content-box .pack-select"),
    y = document.querySelector(".page-step-1"),
    S = document.querySelector(".page-step-2");
    (function syncNextPackWithImage() {
    if (!s) return; // nothing to do if this section doesn't have a .next-pack

    // function apply() {
    //   // always query fresh list (handles elements created later)
    //   const imgs = document.querySelectorAll('.m-image-with-text__image');
    //   imgs.forEach(img => {
    //     // if next-pack is hidden -> move image to bottom:0, else reset
    //     if (s.classList.contains('hidden')) {
    //       img.style.bottom = '0';
    //     } else {
    //       img.style.bottom = '';
    //     }
    //   });
    // }

    // // run once now
    // apply();

    // // observe class changes on the next-pack button so future toggles update automatically
    // try {
    //   const mo = new MutationObserver(apply);
    //   mo.observe(s, { attributes: true, attributeFilter: ['class'] });
    // } catch (err) {
    //   // MutationObserver should be available in modern browsers; fallback: no-op
    //   console.warn('MutationObserver unavailable for next-pack sync', err);
    // }
  })();
  const v = localStorage.getItem("builder_type");
  "single" != v &&
    n.forEach((e) => {
      e.addEventListener("click", function () {
        const a = e.getAttribute("data-open");
        n.forEach((t) => t.classList.remove("active")),
          e.classList.add("active"),
          s.classList.add("hidden"),
          ".page-step-1" == t &&
          (u.classList.remove("hidden"),
            p.classList.add("hidden"),
            g.forEach((t) => t.classList.add("hidden")),
            h.forEach((t) => t.classList.remove("hidden")),
            b(a),
            updateStepIndicators("matching-undie_step_2", ".page-step-1")),
          ".page-step-2" == t &&
          (c.classList.remove("hidden"), r.classList.add("hidden"), b(a)),
          localStorage.setItem("type", a),
          (function () {
            const t = localStorage.getItem("type");
            document.querySelectorAll(".discount-buttons").forEach((e) => {
              e.classList.contains(t)
                ? (e.style.display = "block")
                : (e.style.display = "none");
            });
          })();
        const o = e.closest(".m-section-my");
        o &&
          (window.matchMedia("(min-width: 768px)").matches,
            o.scrollIntoView({ behavior: "smooth", block: "end" }));
      });
    }),
    m.forEach((t) => {
      t.addEventListener("click", function () {
        const e = t.getAttribute("data-quantity"),
          a = t.getAttribute("data-discount");
        u.classList.remove("hidden"),
          "single" != v && p.classList.add("hidden"),
          localStorage.setItem("pack-selected", e),
          localStorage.setItem("pack-discount", a);
        const n = S.getAttribute("data-step");
        y.classList.add("hidden"),
          S.classList.remove("hidden"),
          (function (t) {
            const e = new URL(window.location.href);
            e.searchParams.set("step", t),
              history.pushState({}, "", e),
              localStorage.setItem("current-step", t),
              showAppropriateStep();
          })(n),
          generateHtmlForPacks(e);
        const o = t.closest(".m-section-my");
        o &&
          (window.matchMedia("(min-width: 768px)").matches,
            o.scrollIntoView({ behavior: "smooth", block: "end" }));
      });
    });
  const w = e.querySelectorAll(".review-top .type_button button");
  function b(t) {
    document.querySelectorAll(".review-top .type_button").forEach((e) => {
      e.classList.contains(t)
        ? e.classList.remove("hidden")
        : e.classList.add("hidden");
    });
  }
  w.forEach((t) => {
    t.addEventListener("click", function () {
      w.forEach((t) => t.classList.remove("active")), t.classList.add("active");
      const n = t.getAttribute("data-prev-img"),
        c = t.getAttribute("data-collection"),
        s = t.closest(".type_button").querySelector(".type_product_data"),
        i = t.getAttribute("data-name"),
        l = t.closest(".type_button");
      let u = "";
      s && (u = localStorage.getItem(i)),
        n && d && ((d.src = n), (d.srcset = n)),
        (function () {
          const t = localStorage.getItem("type");
          o.forEach((t) => t.classList.add("hidden"));
          const e = Array.from(o).find(
            (e) => e.getAttribute("data-open") === t
          );
          e && e.classList.remove("hidden");
        })(),
        r.classList.remove("hidden"),
        (function (t) {
          if (!t) return;
          const a = e.querySelector(".sizes-all");
          if (!a) return;
          const n = Array.from(a.querySelectorAll(".m-product-option--node")),
            o = Array.from(t.classList);
          n.forEach((t) => {
            const e = t.getAttribute("data-value");
            o.includes(e.toLowerCase())
              ? t.classList.remove("hidden")
              : t.classList.add("hidden");
          });
        })(l),
        (function (t, e) {
          decodeURIComponent(t);
          const a = JSON.parse(t);
          try {
            allProductsData.hasOwnProperty(`allProduct-${e}`) ||
              (allProductsData[`allProduct-${e}`] = a),
              (commonProductsData = findAllCommonProducts(e));
          } catch (t) { }
        })(u, i),
        generateHtmlForCommonProducts(),
        hidepackofSwatchFromBuildAPackPage(),
        updateDesignCounts(),
        setupTabButtonClickHandlers(),
        setupTabSwatchClickHandlers(),
        localStorage.setItem("product-type", i),
        localStorage.setItem(`${a}-collection`, c);
      const m = t.closest(".m-section-my");
      m &&
        (window.matchMedia("(min-width: 768px)").matches,
          m.scrollIntoView({ behavior: "smooth", block: "end" }));
    });
  }),
    i.forEach((t) => {
      t.addEventListener("change", function () {
        allowTypeButtonClick = false; // prevent unwanted click

        const activeButtons = document.querySelectorAll('.pack-swatch-button button.active');
        const pack = parseInt(localStorage.getItem("pack-selected"), 10);
        const reviewButton = document.querySelector('.review-button');

        if (this.checked) {
          // l.classList.remove("hidden");
          if (activeButtons.length === pack) {
            s.classList.add('hidden');
            reviewButton.classList.remove('hidden');
          } else {
            reviewButton.classList.add('hidden');
            s.classList.remove('hidden');
          }
          localStorage.setItem("size-selected", this.value);
        }

        // Only click if allowed
        if (allowTypeButtonClick && activeTab) {
          activeTab.click();
        }

        // Re-enable the click later (after 100ms)
        setTimeout(() => {
          allowTypeButtonClick = true;
        }, 100);
      });
    }),
    document.addEventListener("DOMContentLoaded", function () {
      const t = new URLSearchParams(window.location.search).get("callback");
      t && window[t] && "function" == typeof window[t] && window[t]();
    });
}
function fetchProductVariantIdByHandle(t, e) {
  return fetch("/products/" + t + ".json")
    .then(function (e) {
      if (e.ok) return e.json();
      throw new Error("Error fetching product by handle: " + t);
    })
    .then(function (t) {
      var a = t.product.variants.find(function (t) {
        return t.title === e;
      });
      return a ? a.id : null;
    });
}
async function addProductsToCartBulk(t, e) {
  (document.querySelector("#pack-atc").style.color = "#DCFF9C2a"),
    (document.getElementById("spinner-atc").style.display = "block"),
    (document.getElementById("animate-spin-p").style.display = "block");
  const a = (
    await Promise.all(
      t.map(async (t) => {
        const a = await fetchProductVariantIdByHandle(t.handle, t.size);
        return a
          ? { id: a, quantity: 1, properties: { comboType: `PACK OF ${e}` } }
          : null;
      })
    )
  ).filter((t) => null !== t);
  if (0 === a.length) return;
  let n = { items: a };
  await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(n),
  })
    .then((t) => t.json())
    .then((t) => {
      if (window.MinimogSettings && window.MinimogSettings.use_ajax_atc) {
        updateCartUI(),
          window.MinimogSettings.enable_cart_drawer
            ? window.MinimogEvents.emit(
              MinimogTheme.pubSubEvents.openCartDrawer
            )
            : window.MinimogTheme.Notification.show({
              target: document.body,
              method: "appendChild",
              type: "success",
              message: "Items added to cart",
              last: 3e3,
              sticky: !1,
            });
        document
          .getElementById("MinimogCartDrawer")
          .classList.add("m-cart-drawer--active"),
          window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, t);
      } else window.location = window.MinimogSettings.routes.cart;
    })
    .catch((t) => { }),
    (document.getElementById("spinner-atc").style.display = "none"),
    (document.getElementById("animate-spin-p").style.display = "none"),
    (document.querySelector("#pack-atc").style.color = "#DCFF9C");
}
async function updateCartUI() {
  await updateCartSection(
    "/cart?section_id=cart-template",
    "[data-minimog-cart-items]",
    "[data-cart-subtotal]",
    "[data-minimog-cart-discounts]",
    "[data-minimog-gift-wrapping]"
  ),
    await updateCartSection(
      "/cart?section_id=cart-drawer",
      "[data-minimog-cart-items]",
      "[data-cart-subtotal]",
      "[data-minimog-cart-discounts]",
      "[data-minimog-gift-wrapping]"
    );
  const t = await fetch("/cart.js").then((t) => t.json()),
    e = document.getElementById("MinimogCartDrawer");
  e && e.classList.remove("m-cart--empty"),
    updateCartCount(t.item_count),
    openCartDrawer();
}
async function updateCartSection(t, e, a, n, o) {
  try {
    const c = await fetch(t),
      r = await c.text(),
      s = new DOMParser().parseFromString(r, "text/html"),
      i = s.querySelector(e).innerHTML;
    document.querySelectorAll(e).forEach((t) => (t.innerHTML = i));
    const d = s.querySelector(a).innerHTML;
    document.querySelectorAll(a).forEach((t) => (t.innerHTML = d));
    const l = s.querySelector(n).innerHTML;
    document.querySelectorAll(n).forEach((t) => (t.innerHTML = l));
    const u = s.querySelector(o).innerHTML;
    document.querySelectorAll(o).forEach((t) => (t.innerHTML = u));
  } catch (t) { }
}
function updateCartCount(t) {
  document.querySelectorAll(".m-cart-count-bubble").forEach((e) => {
    t > 0
      ? ((e.textContent = t), e.classList.remove("hidden"))
      : e.classList.add("hidden");
  });
}
function updateGlobalCartCount(t) {
  document.querySelectorAll(".m-cart-count-bubble").forEach((e) => {
    t > 0
      ? ((e.textContent = t), e.classList.remove("m:hidden"))
      : ((e.textContent = ""), e.classList.add("m:hidden"));
  });
}
function openCartDrawer(t) {
  const e = document.querySelector(".m-cart-drawer"),
    a = document.querySelector(".m-cart-drawer__inner");
  e &&
    a &&
    (t && setActiveElement(t),
      e.classList.add("m-cart-drawer--active"),
      e.classList.remove("m-cart--empty"),
      requestAnimationFrame(() => {
        document.documentElement.style.setProperty("--m-bg-opacity", "0.5"),
          a.style.setProperty("--translate-x", "0");
      }),
      window.MinimogEvents &&
      MinimogTheme &&
      MinimogTheme.pubSubEvents &&
      window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer));
}
async function fetchLatestCartCount() {
  return new Promise((t) => {
    t(parseInt(localStorage.getItem("cartItemCount"), 10) || 0);
  });
}
function updateCartCount(t) {
  document.querySelectorAll(".m-cart-count-bubble").forEach((e) => {
    t > 0
      ? ((e.textContent = t), e.classList.remove("hidden"))
      : e.classList.add("hidden");
  });
}




function getAllSwatchIconsFromLocalStorage() {
  const iconSet = new Set();

  // Step 1: Extract swatch icons from specific keys
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (["Boxer Brief", "Boxers", "Briefs", "Trunk"].includes(key)) {
      try {
        const products = JSON.parse(localStorage.getItem(key));
        products.forEach(product => {
          if (product.swatch_icon && !product.swatch_icon.includes("ivory.png")) {
            iconSet.add(product.swatch_icon);
          }
        });
      } catch (e) {
        console.error(`Error parsing ${key}:`, e);
      }
    }
  }

  // Step 2: Convert to array
  const uniqueIcons = Array.from(iconSet);
  console.warn("✨ Unique Swatch Icons:", uniqueIcons);

  // Step 3: Replace .pack-icon-image with swatch icons based on data-quantity
  const packSelectors = document.querySelectorAll('.pack-selector-btn-main');

  packSelectors.forEach(selector => {
    const qty = parseInt(selector.getAttribute('data-quantity'), 10);
    const container = selector.querySelector('.pack-select-image-container');

    if (!container || isNaN(qty)) return;

    container.innerHTML = ''; // Clear existing image(s)

    for (let i = 0; i < qty && i < uniqueIcons.length; i++) {
      const img = document.createElement('img');
      img.src = uniqueIcons[i];
      img.className = 'pack-icon-image';
      img.style.display = 'inline-block';
      container.appendChild(img);
    }
  });
}






showAppropriateStep(),
  (window.onpopstate = function (t) {
    showAppropriateStep();
  }),
  document.addEventListener("DOMContentLoaded", () => {
    getAllSwatchIconsFromLocalStorage();
    handleSectionActions(".page-step-1"), handleSectionActions(".page-step-2");
  }),
  document.addEventListener("DOMContentLoaded", () => {
    const t = document.getElementById("add-to-pack"),
      e = document.getElementById("review");
    function a() {
      const t = document.querySelectorAll(".pack-swatch-button button.active"),
        e = document.getElementById("count-dy");
      e && (e.textContent = t.length);
    }
    function n(t, e, a, sizespan) {
      t.classList.remove("active"),
        t.removeAttribute("data-type"),
        t.removeAttribute("data-id"),
        t.removeAttribute("data-handle"),
        t.removeAttribute("data-size"),
        t.removeAttribute("data-design"),
        t.removeAttribute("data-price"),
        t.removeAttribute("data-prev"),
        (e.src = ""),
        (e.style.display = 'none'),
        (e.setAttribute('data-filled', 'false')),
        (a.textContent = "");
        // if(sizespan){
        //   (sizespan.remove());
        // }
    }
    function o(t, e, a, n, sizespan) {
      const o = e.querySelector("img"),
        c = e.nextElementSibling;
        const parentsizeSpanDiv = e.parentElement;
        const sizeSpannext = parentsizeSpanDiv ? parentsizeSpanDiv.querySelector('.size-span') : null;
        const closeBtnNext = parentsizeSpanDiv ? parentsizeSpanDiv.querySelector('.close') : null;
        if(!closeBtnNext.classList.contains("hidden")){
          closeBtnNext.classList.add('hidden');
        }
      t.classList.add("active"),
        t.setAttribute("data-type", e.getAttribute("data-type")),
        t.setAttribute("data-id", e.getAttribute("data-id")),
        t.setAttribute("data-handle", e.getAttribute("data-handle")),
        t.setAttribute("data-size", e.getAttribute("data-size")),
        t.setAttribute("data-design", e.getAttribute("data-design")),
        t.setAttribute("data-price", e.getAttribute("data-price")),
        t.setAttribute("data-prev", e.getAttribute("data-prev")),
        (a.src = o.src),
        (n.textContent = c.textContent);
        // if(sizespan && !sizeSpannext){
        //   sizespan.remove();
        // }
        if(sizespan && sizeSpannext){
          sizespan.textContent = sizeSpannext.textContent;
          // sizeSpannext.remove();
        }
        t
          .closest(".pack-swatch")
          .querySelector(".close")
          .classList.remove("hidden");
    }
    function c() {
      const t = document.querySelector(".review-button"),
        e = document.querySelectorAll(".pack-swatch-button button.active"),
        a = document.querySelector(".add-to-pack"),
        n = parseInt(localStorage.getItem("pack-selected"), 10);
      e.length === n
        ? (a.classList.add("hidden"), t.classList.remove("hidden"))
        : (t.classList.add("hidden"), a.classList.remove("hidden"));
    }
    t.addEventListener("click", function () {
      const t = document.querySelectorAll(".pack-swatch-button button"),
        e = Array.from(t).find((t) => !t.classList.contains("active"));
      if (e) {
        e.setAttribute("data-type", localStorage.getItem("product-type")),
          e.setAttribute("data-id", localStorage.getItem("product-id")),
          e.setAttribute("data-handle", localStorage.getItem("product-handle")),
          e.setAttribute("data-size", localStorage.getItem("size-selected")),
          e.setAttribute("data-design", localStorage.getItem("designName")),
          e.setAttribute("data-price", localStorage.getItem("product-price")),
          e.setAttribute("data-prev", localStorage.getItem("product-prev")),
          e.classList.add("active");
        const t = e.querySelector("img");
        t && (t.src = localStorage.getItem("product-prev"));
        const a = e.nextElementSibling;
        a &&
          a.classList.contains("price") &&
          (a.textContent = "Rs." + localStorage.getItem("product-price"));
        const n = e.parentElement.querySelector(".close");
        n && n.classList.remove("hidden");

        let currecurrentSwatchIndexdiv = document.querySelector("#pack-prevew-div");
        let currecurrentSwatchIndexvalue = Number(currecurrentSwatchIndexdiv.dataset.currentswatch) || 0;
        currecurrentSwatchIndexvalue += 1;

        const swatchImgs = document.querySelectorAll('#pack-prevew-div .pack-swatch img');

        if(currecurrentSwatchIndexvalue < swatchImgs.length){
          currecurrentSwatchIndexdiv.dataset.currentswatch = currecurrentSwatchIndexvalue.toString();
        }else{
          currecurrentSwatchIndexdiv.dataset.currentswatch = swatchImgs.length - 1;
        }
        
      }
      c(), a();
      setupTabSwatchClickHandlers();
    }),
      e.addEventListener("click", async function () {
        const t = document.querySelectorAll(
          ".pack-swatch-button button.active"
        ),
          e = Array.from(t).map((t) => ({
            type: t.getAttribute("data-type"),
            id: t.getAttribute("data-id"),
            handle: t.getAttribute("data-handle"),
            size: t.getAttribute("data-size"),
            price: t.getAttribute("data-price"),
            img: t.getAttribute("data-prev"),
            design: t.getAttribute("data-design"),
          })),
          a = document.querySelector(".preview-top-section"),
          n = document.querySelector(".preview-section");
        //  a.classList.add("hidden"),
        //  n.classList.remove("hidden"),
        localStorage.setItem("all-pack-products", JSON.stringify(e));
        const o = parseInt(localStorage.getItem("pack-selected"), 10),
          c = parseFloat(localStorage.getItem("pack-discount")),
          r = parseFloat(localStorage.getItem("pack-discount")) / 100;
        document
          .querySelectorAll(".pack-of")
          .forEach((t) => (t.textContent = o)),
          document
            .querySelectorAll(".pack-type-of")
            .forEach((t) => (t.textContent = `${localStorage.getItem("type")}s`)),
          document
            .querySelectorAll(".pack-discount")
            .forEach((t) => (t.textContent = `${c}%`));
        const s = e.reduce(
          (t, e) => t + (parseFloat(e.price.replace(/,/g, "")) || 0),
          0
        );
        if (isNaN(s)) return;
        const i = s * (1 - c / 100),
          d = s - i;
        (document.querySelector(
          ".no-discount-price"
        ).textContent = `Rs. ${s.toFixed(2)}`),
          (document.querySelector(
            ".pack-discount-price"
          ).textContent = `Rs. ${i.toFixed(2)}`),
          (document.querySelector(
            ".pack-total-saving"
          ).textContent = `Rs. ${d.toFixed(2)}`);
        let l = "";
        e.forEach((t) => {
          const e = t.price.replace(/[^0-9.]/g, ""),
            a = parseFloat(e),
            n = a * (1 - r);
          l += `\n             <div class="m-cart-item--drawer__wrapper flex m:items-center" style="margin-left: 0px;margin-right: 0px;background-color: white;border-radius: 15px;">\n                <div class="m-cart-drawer-item__image m-cart-item__image">\n                   <div>\n                      <responsive-image class="m-image m-image-loaded" style="--aspect-ratio: 0.75" intersecting="true">\n                         <img src="${t.img
            }" width="114" height="152" loading="lazy" class="m:w-full m:h-full" sizes="114px">\n                      </responsive-image>\n                   </div>\n                </div>\n                <div class="m-cart-item__info m-cart-drawer-item__info" style="width: -webkit-fill-available;width: 100%;">\n                   <div class="m-cart-drawer-item__variant m:text-color-subtext">\n                      <p class="m-cart-item__option m:text-sm">\n                        SIZE: ${t.size
            }\n                      </p>\n                      <p class="m-cart-item__option m:text-sm">\n                        STYLE: ${t.type
            }\n                      </p>\n                      <p class="m-cart-item__option m:text-sm">\n                        COLOR: ${t.design
            }\n                      </p>\n                   </div>\n                    <div class="flex m:items-center m:justify-between" style="padding-right: 15px;">\n                   <div class="m-cart-item__price">\n                      <div class="m-cart-item__price-discounted">\n                         <span class="m-cart-item__price--final">\n                          Rs. ${n.toFixed(
              2
            )}\n                         </span>\n                         <del class="m-cart-item__price--regular discounted">\n                          Rs. ${a.toFixed(
              0
            )}\n                         </del>\n                      </div>\n                   </div>\n      \n                  \n                    \n                      <m-cart-remove-button id="" data-index="1">\n                         <span class="m-cart-item__remove modify">Modify</span>\n                      </m-cart-remove-button>\n                   </div>\n                </div>\n             </div>\n          `;
        });
        const u = document.querySelector(".preview-pack-products");
        u && (u.innerHTML = l);


        const tt = parseInt(localStorage.getItem("pack-selected"), 10),
          ee = JSON.parse(localStorage.getItem("all-pack-products"));
        ee && ee.length > 0 && (await addProductsToCartBulk(ee, tt));
      }),
      document.addEventListener("click", function (t) {
        if (t.target.closest(".modify")) {
          const t = document.querySelector(".preview-top-section"),
            e = document.querySelector(".preview-section");
          t.classList.remove("hidden"), e.classList.add("hidden");
        }
      }),
      document.addEventListener("click", function (t) {
        if (
          t.target.matches(".pack-swatch .close") ||
          t.target.closest(".pack-swatch .close")
        ) {
          const e = t.target.matches(".close")
            ? t.target
            : t.target.closest(".close"),
            a = e.closest(".pack-swatch");
          let r = a.querySelector(".pack-swatch-button button"),
            s = r.querySelector("img"),
            i = a.querySelector(".price");
            sizespan = a.querySelector(".size-span");
          e.classList.add("hidden"), n(r, s, i, sizespan);
          let d = a.nextElementSibling;
          for (; d;) {
            const t = d.querySelector(".pack-swatch-button button"),
              e = d.querySelector(".close");
            t.classList.contains("active")
              ? (o(r, t, s, i, sizespan),
                (r = t),
                (s = r.querySelector("img")),
                (i = d.querySelector(".price")),
                (sizespan = d.querySelector(".size-span")))
              : e.classList.add("hidden"),
              (d = d.nextElementSibling);
          }
          n(r, s, i, sizespan),
            r
              .closest(".pack-swatch")
              .querySelector(".close")
              .classList.add("hidden"),
            c();
              manageCurrentSwatch(a);
        }
        a();
      }),
      document
        .querySelector("#pack-atc")
        .addEventListener("click", async () => {
          const t = parseInt(localStorage.getItem("pack-selected"), 10),
            e = JSON.parse(localStorage.getItem("all-pack-products"));
          e && e.length > 0 && (await addProductsToCartBulk(e, t));
        });
  });

function manageCurrentSwatch(parentPackSwatchDiv){
  const packPreviewDiv = document.getElementById('pack-prevew-div');
  if (!packPreviewDiv) return;

  const swatches = packPreviewDiv.querySelectorAll('.pack-swatch');
  let newIndex = 0;
  for (let i = 0; i < swatches.length; i++) {
    const closeSpan = swatches[i].querySelector('.close');
    if (closeSpan && closeSpan.classList.contains('hidden')) {
      newIndex = i;
      const sizeSpanEleParent = closeSpan.parentElement.querySelector('.size-span');
      if(sizeSpanEleParent){
        sizeSpanEleParent.remove();
      }
      break;
    }
  }
  packPreviewDiv.dataset.currentswatch = newIndex.toString();
}
// document.querySelectorAll('.tab-button').forEach(function(btn) {
//   btn.addEventListener('click', function () {
//     const type = btn.getAttribute('data-name') || btn.textContent.trim();
//   console.warn('dwdwdwddwdwdd', )
//     // Find the currently active pack swatch image
//     const activeSwatchBtn = document.querySelector('.pack-swatch-img.active');
//     if (activeSwatchBtn) {
//       const styleNameSpan = activeSwatchBtn.closest('.pack-swatch-button').querySelector('.style-name');
//       if (styleNameSpan) {
//         styleNameSpan.textContent = type;
//       }
//     }
//   });
// });

// --- ADD: dynamic text for #add-to-pack based on data-currentswatch + disabledddd ---
function initAddToPackDynamicText() {
  const btn = document.getElementById('add-to-pack');
  const preview = document.getElementById('pack-prevew-div'); // note: "prevew" matches your id
  if (!btn || !preview) return;

  const label = btn.querySelector('.total-price-match');
  if (!label) return;

  // 1 -> FIRST, 2 -> SECOND, ... 15 -> FIFTEENTH, then 16TH, 17TH, ...
  const wordFor = (n) => {
    const map = ["FIRST","SECOND","THIRD","FOURTH","FIFTH","SIXTH","SEVENTH","EIGHTH","NINTH","TENTH","ELEVENTH","TWELFTH","THIRTEENTH","FOURTEENTH","FIFTEENTH"];
    if (n >= 1 && n <= 15) return map[n - 1];
    const j = n % 10, k = n % 100;
    let suf = "TH";
    if (j === 1 && k !== 11) suf = "ST";
    else if (j === 2 && k !== 12) suf = "ND";
    else if (j === 3 && k !== 13) suf = "RD";
    return `${n}${suf}`;
  };

  function update() {
    const hasAttr = btn.hasAttribute('disabledddd'); // requirement: only when attribute exists
    if (!hasAttr) {
      label.textContent = "ADD TO PACK";
      return;
    }
    const idx = parseInt(preview.getAttribute('data-currentswatch'), 10);
    const pairNum = isNaN(idx) ? 1 : (idx + 1); // your index is 0-based
    label.textContent = `LOCK IN YOUR ${wordFor(pairNum)} PAIR`;
  }

  // Initial paint
  update();

  // React to changes on either element
  const obsBtn = new MutationObserver(update);
  obsBtn.observe(btn, { attributes: true, attributeFilter: ['disabledddd'] });

  const obsPreview = new MutationObserver(update);
  obsPreview.observe(preview, { attributes: true, attributeFilter: ['data-currentswatch'] });

  // Expose for manual nudges if you want to call it after custom logic
  window.__updateAddToPackText = update;
}

// run once DOM is ready
document.addEventListener('DOMContentLoaded', initAddToPackDynamicText);

document.getElementById("reviews").addEventListener("click", function (e) {
  e.preventDefault(); // stop default navigation
  document.getElementById("review").click(); // trigger click on #review
});

// document.addEventListener('DOMContentLoaded', () => {
//   let activeSlot = null;

//   // pick a slot manually
//   document.addEventListener('click', (e) => {
//     const slotClicked = e.target.closest('.pack-swatch-img');
//     if (slotClicked) {
//       e.preventDefault();
//       document.querySelectorAll('.pack-swatch-img').forEach(s => s.classList.remove('active-slot'));
//       slotClicked.classList.add('active-slot');
//       activeSlot = slotClicked;
//       console.debug('Active slot set to', activeSlot.dataset.position);
//       return;
//     }

//     const swatch = e.target.closest('.tab-swatch');
//     if (!swatch) return;
//     e.preventDefault();

//     // try mapping by data-currentswatch
//     const cs = swatch.getAttribute('data-currentswatch') ?? swatch.dataset.currentswatch;
//     let slot = null;
//     if (cs != null) {
//       const idx = parseInt(cs, 10);
//       if (!isNaN(idx)) {
//         const slotPos = idx + 1;
//         slot = document.querySelector(`.pack-swatch-img[data-position="${slotPos}"]`);
//         console.debug('Mapping by currentswatch', cs, '->', slotPos, slot);
//       }
//     }

//     // fallback to activeSlot or first slot
//     if (!slot) {
//       slot = activeSlot || document.querySelector('.pack-swatch-img[data-position]') || document.querySelector('.pack-swatch-img');
//       console.debug('Fallback slot chosen:', slot && slot.dataset.position);
//     }

//     if (!slot) {
//       console.warn('No slot available to fill.');
//       return;
//     }

//     let newImg = swatch.getAttribute('data-previmg') || swatch.dataset.previmg;
//     if (!newImg) {
//       console.warn('Swatch missing data-previmg:', swatch);
//       return;
//     }
//     if (newImg.startsWith('//')) newImg = window.location.protocol + newImg;

//     // replace/create image
//     let img = slot.querySelector('img');
//     if (!img) {
//       img = document.createElement('img');
//       slot.appendChild(img);
//     }
//     img.onload = () => img.style.display = 'block';
//     img.src = newImg;
//     img.setAttribute('data-filled', 'true');
//     img.style.display = 'block';

//     // update slot dataset
//     slot.dataset.id = swatch.getAttribute('data-pid') || '';
//     slot.dataset.handle = swatch.getAttribute('data-phanlde') || swatch.getAttribute('data-handle') || '';
//     slot.dataset.design = swatch.getAttribute('data-name') || '';
//     slot.dataset.price = swatch.getAttribute('data-price') || '';
//     slot.dataset.prev = newImg;

//     // NOTE: do NOT clear activeSlot here so subsequent fills can still target it
//     console.info('Filled slot', slot.dataset.position, 'with', newImg);
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector("#pack-prevew-div");
  if (!container) return;

  document.addEventListener("click", (e) => {
    const swatch = e.target.closest(".tab-swatch");
    if (!swatch) return;
    e.preventDefault();

    // --- read current index (0-based) ---
    let currentIndex = parseInt(container.getAttribute("data-currentswatch"), 10);
    if (Number.isNaN(currentIndex) || currentIndex < 0) currentIndex = 0;

    const slots = Array.from(document.querySelectorAll(".pack-swatch-img"));
    const totalSlots = slots.length;

    // --- map index to slot position (1-based) ---
    const slotPos = currentIndex + 1;
    if (slotPos > totalSlots) return;

    const slot = document.querySelector(`.pack-swatch-img[data-position="${slotPos}"]`);
    if (!slot) return;

    // --- get swatch image ---
    let newImg = swatch.getAttribute("data-previmg") || swatch.dataset.previmg;
    if (!newImg) return;
    if (newImg.startsWith("//")) newImg = window.location.protocol + newImg;

    // --- update slot image ---
    let imgEl = slot.querySelector("img");
    if (!imgEl) {
      imgEl = document.createElement("img");
      slot.appendChild(imgEl);
    }
    imgEl.src = newImg;
    imgEl.setAttribute("data-filled", "true");
    imgEl.style.display = "block";

    // --- update slot metadata ---
    // slot.dataset.id = swatch.getAttribute("data-pid") || "";
    // slot.dataset.handle = swatch.getAttribute("data-phanlde") || swatch.getAttribute("data-handle") || "";
    // slot.dataset.design = swatch.getAttribute("data-name") || "";
    // slot.dataset.price = swatch.getAttribute("data-price") || "";
    slot.dataset.prev = newImg;

    // --- increment AFTER filling ---
    let nextIndex = currentIndex;
    if (nextIndex >= totalSlots) nextIndex = totalSlots - 1; // clamp
    container.setAttribute("data-currentswatch", nextIndex);

    console.info(
      `✅ Filled slot ${slotPos} (currentswatch was ${currentIndex}) → now currentswatch=${nextIndex}`
    );
  });
});

// document.addEventListener("DOMContentLoaded", () => {
//   const container = document.querySelector("#pack-prevew-div");
//   if (!container) return;

//   document.addEventListener("click", (e) => {
//     const swatch = e.target.closest(".tab-swatch");
//     if (!swatch) return;
//     e.preventDefault();

//     // --- get current index safely (0-based) ---
//     let currentIndex = parseInt(container.getAttribute("data-currentswatch"), 10);
//     if (Number.isNaN(currentIndex) || currentIndex < 0) currentIndex = 0;

//     const slots = Array.from(document.querySelectorAll(".pack-swatch-img"));
//     const totalSlots = slots.length;
//     const slotPos = currentIndex + 1;

//     if (slotPos < 1 || slotPos > totalSlots) return;

//     const slot = document.querySelector(`.pack-swatch-img[data-position="${slotPos}"]`);
//     if (!slot) return;

//     // --- get swatch image ---
//     let newImg = swatch.getAttribute("data-previmg") || swatch.dataset.previmg;
//     if (!newImg) return;
//     if (newImg.startsWith("//")) newImg = window.location.protocol + newImg;

//     // --- reuse existing <img> or create if none ---
//     let imgEl = slot.querySelector("img");
//     if (!imgEl) {
//       imgEl = document.createElement("img");
//       slot.appendChild(imgEl);
//     } else {
//       imgEl.onload = null; // clear old handler
//     }

//     imgEl.onload = () => (imgEl.style.display = "block");
//     imgEl.src = newImg;
//     imgEl.setAttribute("data-filled", "true");
//     imgEl.style.display = "block";

//     // --- update slot dataset ---
//     slot.dataset.id = swatch.getAttribute("data-pid") || "";
//     slot.dataset.handle = swatch.getAttribute("data-phanlde") || swatch.getAttribute("data-handle") || "";
//     slot.dataset.design = swatch.getAttribute("data-name") || "";
//     slot.dataset.price = swatch.getAttribute("data-price") || "";
//     slot.dataset.prev = newImg;

//     // --- increment current index ---
//     const nextIndex = Math.min(currentIndex + 1, totalSlots - 1);
//     container.setAttribute("data-currentswatch", nextIndex);
//   });
// });

